import styled, { keyframes } from 'styled-components';

// Animation for loading spinner
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// Progress bar animation
const progressAnimation = keyframes`
  0% { width: 0; opacity: 0.1; }
  20% { opacity: 0.5; }
  100% { opacity: 0.8; }
`;

// Progress bar component
export const ProgressBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background-color: ${props => props.theme.colors.SECONDARY_LIGHT};
  width: ${props => `${props.value}%`};
  border-radius: 0 3px 3px 0;
  animation: ${progressAnimation} 0.3s ease;
  z-index: 2;
`;

// Spinner component
export const LoadingSpinner = styled.div`
  width: ${props => props.size === 'small' ? '14px' : props.size === 'large' ? '20px' : '16px'};
  height: ${props => props.size === 'small' ? '14px' : props.size === 'large' ? '20px' : '16px'};
  border: 2px solid ${props => props.theme.colors.NEUTRAL_10};
  border-radius: 50%;
  border-top-color: ${props => props.theme.colors.NEUTRAL_40};
  animation: ${spin} 0.8s linear infinite;
  z-index: 2;
`;